<template lang="pug">
    filter-mobile
        form.c-form.inverse

            // Sort by Full Name
            div(v-if="filters && Object.keys(filters).length")
                div(v-for="(filter, key) in filters" :key="key")

                    // Custom filters
                    v-select(
                        v-if="key === 'businessNames' && filter && filter.length >= 1"
                        :name="key"
                        append-icon="expand_more"
                        outline
                        @change="e => filterHandler({ name: $t(`users.mobile.filter.${key}.value`), value: e})"
                        :items="filterItems(filter)"
                        :label="$t($t(`users.mobile.filter.${key}.name`))"
                    )

                    div {{ $t(`users.mobile.filter.${key}.name`) }}
</template>

<script>
    import VueTypes from 'vue-types';
    import FilterMobile from '~components/FilterMobile';

    export default {
        components: {
            FilterMobile
        },
        props: {
            filters: VueTypes.object.def({}),
            filterHandler: VueTypes.func.def(() => {})
        },
        methods: {
            /**
             * Items for filter
             */
            filterItems(filter) {
                if (typeof filter === 'object') return filter;

                const customFilters = this.filters[filter].map(item => {
                    return { title: item, value: item };
                });

                return [
                    {
                        title: 'All',
                        value: null
                    },
                    ...customFilters
                ];
            }
        }
    };
</script>
